export default function LoadingFechamento() {
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <div className="h-4 w-24 animate-pulse rounded bg-slate-200" />
      <div className="h-16 w-80 animate-pulse rounded-lg bg-slate-200" />
      <div className="h-12 animate-pulse rounded-xl border border-slate-200 bg-white" />
      <div className="grid gap-3 sm:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-24 animate-pulse rounded-xl border border-slate-200 bg-white p-4">
            <div className="h-3 w-24 rounded bg-slate-100" />
            <div className="mt-3 h-7 w-32 rounded bg-slate-100" />
          </div>
        ))}
      </div>
      <div className="grid gap-4 lg:grid-cols-2">
        <div className="h-72 animate-pulse rounded-xl border border-slate-200 bg-white" />
        <div className="h-72 animate-pulse rounded-xl border border-slate-200 bg-white" />
      </div>
      <div className="h-96 animate-pulse rounded-xl border border-slate-200 bg-white" />
    </div>
  );
}
